import { render, staticRenderFns } from "./ThemeactivityDetail.vue?vue&type=template&id=516e68e2&scoped=true"
import script from "./ThemeactivityDetail.vue?vue&type=script&lang=js"
export * from "./ThemeactivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e68e2",
  null
  
)

export default component.exports